module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAABHNCSVQICAgIfAhkiAAAAO1JREFUKFOt0j9OAkEYBfD3FpeCwmA8gFhADWYJHVlOYjwCN7C3kRtwk1k6Nk4iLduAhs4GOg0bnpkNFERDspOdbibz/fL9o7HZlMAj/M5W0BMTm0m18GbUu9+WdYzNXgG1CiSOOiwLuP/mbfkMMC4QAIkP4rKQ+HFC/AwAEmbVIU7zSoVqQVxX19hKpuMQSQEAN+rDsTR3d0ckT29nVZ+N2CHGZnMCA5FjSFcEXo4Rn3HUufuvZ3+QNN3c/tTyegP1XRgG3O2/r4vAYJ8PH9pfFxFjlwuKAlF67YtlYzCheV81keddrxEDGPXbyS88koMW0tiNlAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/iconpaymentdd.png
// module id = 991
// module chunks = 0